export enum EligibilityDataSource {
  EDI = 'EDI',
  PayerPortal = 'PayerPortal',
  ManualEntry = 'ManualEntry'
}
